<ng-container *ngIf="!isSdfCardFlow">
  <div *ngIf="!!title" class="mg-summary-body">
    <div class="mg-summary-row">
      <h5 [ngClass]="title?.isBold ? 'text-bold' : ''">{{ title?.name }}</h5>
      <p class="title-value" *ngIf="title?.value">{{ title?.value }}</p>
    </div>
    <hr />
  </div>

  <div class="mg-summary-body">
    <div class="mg-summary-row" *ngFor="let item of items">
      <h5
        *ngIf="item?.value !== 'undefined'"
        [ngClass]="item?.isBold ? 'text-bold' : ''"
      >
        {{ item?.name }}
      </h5>
      <p *ngIf="item?.name !== 'ID number' && item?.value !== 'undefined'">
        {{ item?.displayMinus ? "-" : "" }}{{ item?.value }}
        {{ item?.sendCurrency }}
      </p>
      <div *ngIf="item?.name === 'ID number' && item?.value !== 'undefined'">
        <span *ngIf="!showIdValue"
          >&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;</span
        >
        <span *ngIf="showIdValue">{{ item?.value }}</span>
        <button class="id-view-on-off-button" (click)="toggleIdDisplay()">
          <img *ngIf="showIdValue" src="assets\images\view-on-icon.svg" />
          <img *ngIf="!showIdValue" src="assets\images\view-off-icon.svg" />
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="!!footer" class="mg-summary-body">
    <hr />
    <div class="mg-summary-row">
      <h5 [ngClass]="footer?.isBold ? 'text-bold' : ''">{{ footer?.name }}</h5>
      <p [ngClass]="footer?.isBold ? 'text-bold' : ''">
        {{ footer?.displayMinus ? "-" : "" }}{{ footer?.value }}
        {{ footer?.sendCurrency }}
      </p>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="isSdfCardFlow">
  <div class="card-summary-item-wrapper">
    <div class="title-container">
      <div class="payment-info" *ngIf="!!title">
        <span class="title">
          {{ title?.name }}
        </span>
        <span class="value">
          {{ title?.value }}
        </span>
      </div>
      <div class="divider"></div>
    </div>
    <div class="details" *ngFor="let item of items">
      <div class="detail-fields">
        <ng-container *ngIf="item?.value !== 'undefined'">
          <div class="title-container">
            <span
              class="title"
              [ngClass]="{ locationName: items.length === 1 }"
            >
              {{ item?.name }}
            </span>
            <span
              class="value address"
              *ngIf="item?.name !== 'ID number'"
              [ngClass]="{ address: items.length === 1 }"
            >
              {{ item?.displayMinus ? "-" : "" }}{{ item?.value }}
              {{ item?.sendCurrency }}
            </span>
            <ng-container *ngIf="item?.name === 'ID number'">
              <span class="value" *ngIf="!showIdValue"
                >&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;</span
              >
              <span class="value" *ngIf="showIdValue">{{ item?.value }}</span>
              <span class="id-view-on-off-button" (click)="toggleIdDisplay()">
                <img *ngIf="showIdValue" src="assets\images\view-on-icon.svg" />
                <img
                  *ngIf="!showIdValue"
                  src="assets\images\view-off-icon.svg"
                />
              </span>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="footer-container" *ngIf="!!footer">
      <div class="divider"></div>
      <div class="total-cost-container">
        <span class="total-cost">
          {{ footer?.name }}
        </span>
        <span class="value">
          {{ footer?.displayMinus ? "-" : "" }}{{ footer?.value }}
          {{ footer?.sendCurrency }}
        </span>
      </div>
    </div>
  </div>
</ng-container>
